import React from 'react';
import SettingsForm from '@/components/SettingsForm';

const SettingsPage: React.FC = () => {
  return <SettingsForm />;
};

export default SettingsPage;
